export default "__VITE_ASSET__DzGQ9aaD__"